module.exports = __webpack_public_path__ + "static/media/fly0055.3775233c.webp";